var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`separator-container ${_vm.hideLine ? 'separator-just-start' : ''}`},[_c('p',{staticClass:"separator-title"},[_vm._v(_vm._s(_vm.title))]),(!_vm.hideLine)?_c('div',{staticClass:"separator-line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }